<!-- <p>roles-list works!</p> -->
<div class="container-fluid">
    <div class="row">
        <div class="row mt-8 justify-content-between">
            <div class="col-xs-12 col-sm-5 col-md-4 col-lg-2">
              <h1 class="h3 ml-4 mr-md-6 mr-sm-1 heading">
                TAGS
            </h1>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2 mb-2 d-flex justify-content-end" *ngIf="isUserAllowedToCreateTags"></div>

            <button class="ml-4 addBtn" [ngClass]="{'btn-clr': true}" mat-flat-button [color]="'primary'"
            (click)="createTag()">
            <mat-icon class="white-icon" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            <span class="ml-2 mr-1 txt" style="color: white">Create Tag</span>
        </button>

            </div>
            </div>
        <div class="row ">
                
                    
            <div class="col-sm-12 col-md-4 col-lg-2">
                <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 95%;">
                    <mat-select [placeholder]="'Active Tags'" [(ngModel)]="IDTag.tagActive" (selectionChange)="onFilterTags()">
                        <mat-option value="">All</mat-option>
                        <mat-option *ngFor="let tag of TagsStatusType" [value]="tag.value">{{tag.viewValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-2 mb-2">
                <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 90%;" [subscriptSizing]="'dynamic'">
                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <input matInput (keyup)="applyFilter($event)" [autocomplete]="'off'"
                           [placeholder]="'Search Tag Name'">
                </mat-form-field>
            </div>
           
    </div>
    <div class="mat-elevation-z8 mt-2 overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

            <!-- ID Column -->
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef >Name</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row"> {{row.name}}
                </td>
            </ng-container>
            <ng-container matColumnDef="Alias">
                <th mat-header-cell *matHeaderCellDef >Alias</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row"> {{row.alias}}
                </td>
            </ng-container>
           <ng-container matColumnDef="CreatedBy">
                <th mat-header-cell *matHeaderCellDef >Created By</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row"> {{row.created_by.full_name}}({{row.created_by.role.name}}) </td>

            </ng-container>
            <ng-container matColumnDef="CreatedDate">
                <th mat-header-cell *matHeaderCellDef >Created Date</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row">{{row.created_at  | dateFormat}}
                </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                <!-- <mat-cell style="height: 52px;align-items: center;justify-content: center;" *matCellDef="let row;"> -->
                    <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row "> 
                    <button mat-button [matMenuTriggerFor]="menu"
                        [disabled]="!isUserAllowedToEditTags && !isUserAllowedToDeactivateTags && !isUserAllowedToReactivateTags">
                        <mat-icon
                            style="color:#0038FF;font-size: 30px;"
                            [disabled]="(isUserAllowedToEditTags && isUserAllowedToDeactivateTags && isUserAllowedToReactivateTags)"
                            svgIcon="heroicons_outline:dots-vertical">
                        </mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngIf="!row.is_removed && isUserAllowedToEditTags"
                            (click)="editTags(row)">Edit</button>
                        <button mat-menu-item *ngIf="!row.is_removed && isUserAllowedToDeactivateTags"
                            (click)="verifyDeactivate(row.id)">Deactivate</button>
                        <button mat-menu-item *ngIf="row.is_removed && isUserAllowedToReactivateTags"
                            (click)="reactivateTags(row.id)">Reactivate</button>
                    </mat-menu>
                    </td>

                <!-- </mat-cell> -->

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <div>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="12">
                        <h3 style="display: flex;justify-content: center; margin:10%;">
                            No Records Found
                        </h3>
                    </td>
                </tr>
            </div>
        </table>
    </div>
    <mat-paginator style="display:flex;justify-content: end;" 
    (page)="onPaginateChange($event)" [length]="totalCount"
    [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 100]"
    aria-label="Select page of users" showFirstLastButtons></mat-paginator>
</div>